import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Benchmarks from './pages/Benchmarks';
import ModelDetail from './components/ModelDetail';
import Blog from './pages/Blog';
import FirstPost from './pages/blog/FirstPost';
import SecondPost from './pages/blog/SecondPost';
import { initialProviderFilters } from './pages/modelData';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#f48fb1',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
});

function App() {
  const [filters, setFilters] = useState({
    openSource: false,
    providers: initialProviderFilters
  });
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Navbar />
        <Routes>
          <Route 
            path="/" 
            element={
              <Home 
                filters={filters}
                setFilters={setFilters}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            } 
          />
          <Route path="/benchmarks" element={<Benchmarks />} />
          <Route path="/models/:modelId" element={<ModelDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/first-post" element={<FirstPost />} />
          <Route path="/blog/second-post" element={<SecondPost />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App; 